module.exports = __webpack_public_path__ + "img/ct_address@2x.c9840dde.png";